import { Component,OnInit} from '@angular/core';
import { NavController } from 'ionic-angular';
import {MyUrlService} from '../home/checkUrll';
import {MydataService} from '../home/mydata.service';
import {JsonData} from '../home/dataaa';
import  { Http } from '@angular/http';
import { Device } from '@ionic-native/device';
import { AlertController } from 'ionic-angular';
import {MyvariableService} from '../home/constantvariable';
import {MycartPage} from '../mycart/mycart';
import{KiloPartyPage} from '../kiloparty/kiloparty';
import { LoadingController } from 'ionic-angular';

@Component({
	selector: 'page-kilopartyproduct',
	templateUrl: 'kilopartyproduct.html',
	providers:[MydataService,MyUrlService,JsonData,Device,MyvariableService]
})
export class KilopartyProductPage implements OnInit{
    jsonDt : Array<JsonData>;
	productdataDt: Array<JsonData>;
	showCartDatatin: Array<JsonData>;
    image:Array<JsonData>;
	minimumQty:string;
	productdetaildataDt : Array<JsonData>;
	categorydataDt: Array<JsonData>;
	checkOutSendDt: Array<JsonData>;
	productdeliveryhoursdata:Array<JsonData>;
	productunits : Array<JsonData>;
	tax = this.MyvariableService.TAX;
	quty=0;
	
	pcs = this.MyvariableService.PCS;
	itemPerPack = this.MyvariableService.ITEMPARPACK;
	partyProdct3 = this.MyvariableService.PARTYPRODUCT3;
	partyProdct2 = this.MyvariableService.PARTYPRODUCT2;
	partyProdct1 = this.MyvariableService.PARTYPRODUCT1;
	packPerson = this.MyvariableService.PACKPERSON;
	FREEDELIVERY= this.MyvariableService.FREEDELIVERY;
	checkbox: boolean;
	disabStarter:string;
	addonprice:any;
	addAddoPrice:any;
	addSufficnt:any;
	addOnSuffPerson:any;
	productName:any;
	takeawayMinValue:any;
	minOrderValue:any;
	deliverych:any;
	checkExitstt:any;
		productAfterCheck: Array<JsonData>;
	
	constructor(public device: Device,public loading: LoadingController,public alerCtrl: AlertController,private http:Http,public navCtrl: NavController,private mydataService: MydataService,private myurlService: MyUrlService,private MyvariableService: MyvariableService) {
		this.checkbox = false;
	}
	
	ngOnInit()
	{
		this.disabStarter="starter";
		this.checkExitstt=0;
		if(this.mydataService.checkInternetFunction()=="0"){
			////console.log("Internet UnAvailable")
			}else  if(this.mydataService.checkInternetFunction()=="1"){
			var productid= window.localStorage.getItem('proid');
			////console.log("productid ===>"+ productid);
			var categoryid = window.localStorage.getItem('localid');
			var session_ids=window.localStorage.getItem('session_ids');
			////console.log("menu cat id-->"+categoryid);
			var kiloSabjiJSONdata = JSON.stringify({"userid":window.localStorage.getItem('userid'),"productid":productid,"categoryid":categoryid,"IMEI":session_ids});
			
			////console.log("Product Url--->"+this.myurlService.KILOPARTYPRODUCTURL+"\n"+"JSON //Parameter--->"+kiloSabjiJSONdata);
			let loader = this.loading.create({content: '',});
			
			loader.present().then(() => {
				this.mydataService.postJSON( this.myurlService.KILOPARTYPRODUCTURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.kiloPrtyService(loader));
				
			});
		}
		
	}
	
	errorFunction= function(loader,error){
		loader.dismiss();
		//console.log(error);
		//alert(error);
	}
	kiloPrtyService=function(loader){
		//console.log("productdetail receive jsondata ==>"+JSON.stringify(this.jsonDt));
		this.ASSISTANCECALL= this.MyvariableService.ASSISTANCECALL;
		this.MINHOUR= this.MyvariableService.MINHOUR;
		this.FREEDELIVERY= this.MyvariableService.FREEDELIVERY;
		this.productdataDt = this.jsonDt.productdata;
		this.addonQty = this.jsonDt.productdata[0].addonQty;
		this.addonPrice = this.jsonDt.productdata[0].addonPrice;
		this.minimumQty = this.jsonDt.productdata[0].minimumOrder;
		this.productunits = this.jsonDt.productunits;
		this.productIds = this.productunits[0].productId;
		//alert(this.productIds);
		this.productdeliveryhoursdata = this.jsonDt.productdeliveryhoursdata;
		
		if(this.jsonDt.productdata[0].productName!=null){
			this.productName = this.jsonDt.productdata[0].productName;
		}
		this.image= this.myurlService.IMAGEURL;
		this.categorydataDt = this.jsonDt.categorydata;
		this.productdetaildataDt = this.jsonDt.productdetaildata;
		this.totalcountDt = this.jsonDt.totalcount;
		this.deliverytimes = window.localStorage.getItem('deliverytimes');
		this.totalcount = this.totalcountDt[0].totalcounts;
		this.quty = parseInt(this.addonQty);
		this.addonprice = parseInt(this.addonPrice);
		this.addAddoPrice = parseInt(this.addonPrice);
		this.addOnSuffPerson =parseInt(this.jsonDt.productdata[0].addonPerson);
		this.addSufficnt = parseInt(this.jsonDt.productdata[0].addonPerson);
		////console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa"+JSON.string//ify(this.productdetaildataDt));
		
		for(var i=0;i< this.categorydataDt.length;i++){
			
			if(this.categorydataDt[i].howManyItems==1)
			{
				window.localStorage.removeItem(this.categorydataDt[i].productcategoryid);
				}else{
				for(var j=1;j <= this.categorydataDt[i].howManyItems;j++){
					window.localStorage.removeItem(this.categorydataDt[i].productcategoryid+"_"+j);
				}
			}
		}
		////console.log("productdata ==>"+JSON.stringify(this.jsonDt.productdata));
		////console.log("categorydata ==>"+JSON.stringify(this.jsonDt.categorydata));
		////console.log("productdetaildata ==>"+JSON.stringify(this.jsonDt.productdetaildata));
		
		for(var i=0;i< this.productdetaildataDt.length;i++ ){
			if (this.productdetaildataDt[i].fixproduct=='1'){
				
				window.localStorage.setItem(this.productdetaildataDt[i].productCategoryId,JSON.stringify(this.productdetaildataDt[i]));
				window.localStorage.setItem(this.productdetaildataDt[i].productid,JSON.stringify(this.productdetaildataDt[i]));
				////console.log(this.productdetaildataDt[i].productid+"<----on Load store Data--->"+window.localStorage.getItem(this.productdetaildataDt[i].productid));
			}
		}
		
		this.kiloPointCheck();
		loader.dismiss();
	}
	kiloPointCheck=function(){
		var userid = window.localStorage.getItem('userid');
		var kiloSabjiJSONdata = JSON.stringify({'userid': userid});
		let loader = this.loading.create({content: '',});
		loader.present().then(() => {
			this.mydataService.postJSON(this.myurlService.USERADDRESS, kiloSabjiJSONdata).subscribe(data => this.jsonDt = data, error => this.errorFunction(loader,error), () => this.productShow(loader));
		});
	}
	
	productShow=function(loader){
		loader.dismiss();
		//console.log("product receive jsondata ==>"+JSON.stringify(this.jsonDt));
		this.minOrderValue = this.jsonDt.orderconfig[0].minOrderValue;
		this.deliverych	 = this.jsonDt.orderconfig[0].deliverycharge;
		this.takeawayMinValue = this.jsonDt.orderconfig[0].takeawayMinValue;
		this.refreshDataFold();
		
	}
	
	addItem(){
		
		this.quty=this.quty+1;
		this.addonprice =this.addonprice+ this.addAddoPrice;
		this.addOnSuffPerson = this.addOnSuffPerson +this.addSufficnt;
		
	}
	
	removeItem(){
		//alert(parseInt(this.quty)+'minimumQty--->'+this.minimumQty);
		if(this.quty>1){
			this.quty=this.quty-1;
			this.addonprice =this.addonprice- this.addAddoPrice;
			this.addOnSuffPerson = this.addOnSuffPerson -this.addSufficnt;
		}
		
	}
	addcart(clickType,categoryDt,productAllData,cartid,proid,price,totalamt,quty)
	{
		//console.log("STARTER===>"+this.disabStarter +" "+clickType+"     "+categoryDt+"     //"+productAllData+"     "+cartid+"    "+proid+" " +price+"   "+totalamt+"  "+quty);
		
		
		////console.log("click---=-=-=-==-=-=-=-=--==-=--==-=-=->>.......>>>>>"+this.disabStarter);
		////console.log("caregory--->"+JSON.stringify(categoryDt));
		var validate = true;
		for( var i =0; i< categoryDt.length;i++) {
			// //console.log("for Loop categoryDt--->"+i);
			if(categoryDt[i].howManyItems >1){
				// //console.log(categoryDt[i].categoryname+"categoryDt.howManyItems"+categoryDt[i].howManyItems+" >0");
				for( var j=1; j <= categoryDt[i].howManyItems ; j++){
					//		//console.log("Category Id ==> "+(categoryDt[i].productcategoryid+"_"+j));
					var value = window.localStorage.getItem((categoryDt[i].productcategoryid+"_"+j));
					////console.log("value  --->"+value);
					if(value==null) {
						//		//console.log("value ==null--->");
						validate = false;
						}else{
						//	//console.log("value !=null--->");
					}
				}
				
				}else{
				var val  = window.localStorage.getItem(categoryDt[i].productcategoryid);
				////console.log("Now In Else Loop  val---> "+val+"categoryDt[i].productcategoryid //==>"+categoryDt[i].productcategoryid);
				if(val == null)
				{
					//	//console.log("if  val==null---> "+val);
					validate = false;
				}
			}
			/* if(howManyiteem==1){
				var  checkProd=window.localStorage.getItem(prodDtt[i].productCategoryId);
				}else{
				checkProd=window.localStorage.getItem(cartid);
				}
				
			}*/
		}
		if(!validate)
		{
			//alert("Please select the item before adding prodcut into cart");
			this.warningAlert();
			
		return;}
		//	//console.log('Device UUID is: ' + this.device.uuid+"     //productAllData--->"+JSON.stringify(productAllData));
		
		////console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaa"+JSON.stringify(productAllData));
		var cattt=null;
		var sendMultipledata=null;
		
	    for(var f=0; f<productAllData.length;f++){
			if(productAllData[f].fixproduct=='1')
			{
				//			//console.log(productAllData[f].productid+ "     <----elsehgfhgfhg send Server //data--->"+window.localStorage.getItem(productAllData[f].productid)+"");
				if(sendMultipledata==null){
					//alert(productAllData[f].productid);
					sendMultipledata=window.localStorage.getItem(productAllData[f].productid);
					}else {
					//alert(productAllData[f].productid);
					sendMultipledata=window.localStorage.getItem(productAllData[f].productid)+","+sendMultipledata;
				}
				}else  if(productAllData[f].fixproduct=='0'){
				if(productAllData[f].productCategoryId!=cattt){
					////console.log("baharaaaaa===>"+categoryDt[f].howManyItems);
					for(var a=1; a<=productAllData[f].howManyItems;a++){
						cattt=productAllData[f].productCategoryId;
						//	//console.log(productAllData[f].productCategoryId+"_"+a+ "     <---- ifsend Server data--->"+window.localStorage.getItem(productAllData[f].productCategoryId+"_"+a)+"<=============================00>"+window.localStorage.getItem(productAllData[f].productCategoryId));
						if(sendMultipledata==null){
							if(window.localStorage.getItem(productAllData[f].productCategoryId+"_"+a)==null){
								sendMultipledata=window.localStorage.getItem(productAllData[f].productCategoryId);
								}else{
								sendMultipledata=window.localStorage.getItem(productAllData[f].productCategoryId+"_"+a);
							}
							}else {
							if(window.localStorage.getItem(productAllData[f].productCategoryId+"_"+a)==null){
								sendMultipledata=window.localStorage.getItem(productAllData[f].productCategoryId)+","+sendMultipledata;
								}else{
								sendMultipledata=window.localStorage.getItem(productAllData[f].productCategoryId+"_"+a)+","+sendMultipledata;
							}
						}
					}}}
		}
		sendMultipledata = "["+sendMultipledata+"]";
		////console.log("aaaaaaaaaaaaaaaaaaaaaaaaaa----->"+     sendMultipledata);
		var session_ids=window.localStorage.getItem('session_ids');
		// alert("hello IMEI--->"+this.device.uuid);
		if(this.mydataService.checkInternetFunction()=="0"){
			////console.log("Internet UnAvailable")
			}else  if(this.mydataService.checkInternetFunction()=="1"){
			
			if(clickType=="starter"){
				//alert("starter");
				var kiloSabjiJSONdata = JSON.stringify({"userid":window.localStorage.getItem('userid'),"categoryid":cartid,"productid":proid,"multidata":JSON.parse(sendMultipledata),"type":this.disabStarter,"price":price,"totalamt":totalamt,"IMEI":session_ids,"qty":'1'});
				}else{
				//alert("addon");
				var kiloSabjiJSONdata = JSON.stringify({"userid":window.localStorage.getItem('userid'),"categoryid":cartid,"productid":proid,"multidata":this.showCartDatatin,"type":this.disabStarter,"price":this.addAddoPrice,"totalamt":this.addonprice,"IMEI":session_ids,"qty":quty});
			}
			////console.log("Product Url--->"+this.myurlService.ADDTOCARTURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
			let loader = this.loading.create({content: '',});
			//this.mydataService.postJSON(this.myurlService.PRODUCTURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => //console.log(error),() =>this.hello(loader));
			////console.log("Pricessss====>"+kiloSabjiJSONdata);
			loader.present().then(() => {
				this.mydataService.postJSON(this.myurlService.ADDTOCARTURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error =>this.errorFunction(loader,error),() =>this.cartService(loader));
			});
			
			
		}
	}
	
	refreshDataFold = function(){
		
		var sendMultipledata=null;
		var cattt=0;
	    for(var f=0; f<this.productdetaildataDt.length;f++){
			if(this.productdetaildataDt[f].fixproduct=='1')
			{
				//			//console.log(productAllData[f].productid+ "     <----elsehgfhgfhg send Server //data--->"+window.localStorage.getItem(productAllData[f].productid)+"");
				if(window.localStorage.getItem(this.productdetaildataDt[f].productid)!=null){
				if(sendMultipledata==null){
					//alert(productAllData[f].productid);
					sendMultipledata=window.localStorage.getItem(this.productdetaildataDt[f].productid);
					}else {
					//alert(productAllData[f].productid);
					sendMultipledata=window.localStorage.getItem(this.productdetaildataDt[f].productid)+","+sendMultipledata;
				}
				}
				}else  if(this.productdetaildataDt[f].fixproduct=='0'){
				if(this.productdetaildataDt[f].productCategoryId!=cattt){
					////console.log("baharaaaaa===>"+categoryDt[f].howManyItems);
					for(var a=1; a<=this.productdetaildataDt[f].howManyItems;a++){
						cattt=this.productdetaildataDt[f].productCategoryId;
						//	//console.log(productAllData[f].productCategoryId+"_"+a+ "     <---- ifsend Server data--->"+window.localStorage.getItem(productAllData[f].productCategoryId+"_"+a)+"<=============================00>"+window.localStorage.getItem(productAllData[f].productCategoryId));
						if(sendMultipledata==null){
							if(window.localStorage.getItem(this.productdetaildataDt[f].productCategoryId+"_"+a)==null){
							if(window.localStorage.getItem(this.productdetaildataDt[f].productCategoryId)!=null){
							sendMultipledata=window.localStorage.getItem(this.productdetaildataDt[f].productCategoryId);}
								}else{
								if(window.localStorage.getItem(this.productdetaildataDt[f].productCategoryId+"_"+a)!=null){
								sendMultipledata=window.localStorage.getItem(this.productdetaildataDt[f].productCategoryId+"_"+a);}
							}
							}else {
							if(window.localStorage.getItem(this.productdetaildataDt[f].productCategoryId+"_"+a)==null){
								sendMultipledata=window.localStorage.getItem(this.productdetaildataDt[f].productCategoryId)+","+sendMultipledata;
								}else{
								sendMultipledata=window.localStorage.getItem(this.productdetaildataDt[f].productCategoryId+"_"+a)+","+sendMultipledata;
							}
						}
					}}}
		}
		if(sendMultipledata!=null){
		sendMultipledata=sendMultipledata.replace(/null,/g,'');
		sendMultipledata = "["+sendMultipledata+"]";
		this.showCartDatatin=JSON.parse(sendMultipledata);
		////console.log("ggggggggvn===>"+this.showCartDatatin);
		this.showCartDatatin=this.showCartDatatin;
		}
	}
	cartService=function(loader){
		
		//console.log("product receive jsondata ==>"+JSON.stringify(this.jsonDt));
		
		this.addtocartDt = this.jsonDt.msg;
		this.totalcountDt = this.jsonDt.totalcount;
		this.totalcount = this.totalcountDt[0].totalcounts;
		this.showCartDatatin = this.jsonDt.kilopartyproduct;
		
		//this.totalcount = this.totalcountDt[0].totalcounts;
		//this.subcategorydataDt= this.jsonDt.subcategorydata;
		//this.image= this.myurlService.IMAGEURL;
		this.checkExitstt=1;
		////console.log("cartdata ==>"+JSON.stringify(this.jsonDt.msg));
		loader.dismiss();
		if(this.addtocartDt=='Exist'){
			this.addcartalert= this.MyvariableService.EXISTPRODUCT;
			this.showAlert();
			}else{
			this.addcartalert= this.MyvariableService.ADDPRODUCT;
			this.showAlert();
		}
		
	}
	
	warningAlert=function() {
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: 'Please select  your menu before adding product into the cart',
			buttons: ['OK']
			
		});
		alert.present();
	}
	
	showAlert=function() {
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: this.addcartalert,
			buttons: [ {
				text: 'Ok',
				handler: data => {
					if(this.disabStarter=="starter"){
						this.disabStarter="addon";
						//window.localStorage.clear();
						//window.localStorage.setItem('localid','2');
						}else{
						//	window.localStorage.clear();
						this.clearLocal();
						
					}	
				}
			}
			]
		});
		
		alert.present();
	}
	
	clearLocal=function(){
		////console.log("asgsjgdjsgjkag====>"+JSON.stringify(this.productdetaildataDt));
		var cattt=null;
		var sendMultipledata=null;
		
	    for(var f=0; f<this.productdetaildataDt.length;f++){
			if(this.productdetaildataDt[f].fixproduct=='1')
			{
				////console.log(this.productdetaildataDt[f].productCategoryId+ "     <----elsehgfhgfhg send Server data--->"+window.localStorage.getItem(this.productdetaildataDt[f].productCategoryId)+"");
				if(sendMultipledata==null){
					window.localStorage.removeItem(this.productdetaildataDt[f].productCategoryId);
					//console.log("111111111111111111"+window.localStorage.getItem(this.productdetaildataDt[f].productCategoryId));
					}else  if(this.productdetaildataDt[f].fixproduct=='0'){
					if(this.productdetaildataDt[f].productCategoryId!=cattt){
						for(var a=1; a<=2;a++){
							cattt=this.productdetaildataDt[f].productCategoryId;
							////console.log(this.productdetaildataDt[f].productCategoryId+"_"+a+ "     <---- ifsend Server data--->"+window.localStorage.getItem(this.productdetaildataDt[f].productCategoryId+"_"+a));
							/*if(sendMultipledata==null){
								
								window.localStorage.removeItem(this.productdetaildataDt[f].productCategoryId+"_"+a);
								//console.log("11222222222222222"+window.localStorage.getItem(this.productdetaildataDt[f].productCategoryId+"_"+a));
								}
							*/
							if(sendMultipledata==null){
								if(window.localStorage.getItem(this.productdetaildataDt[f].productCategoryId+"_"+a)==null){
									window.localStorage.removeItem(this.productdetaildataDt[f].productCategoryId);
									//console.log("11222222222222222"+window.localStorage.getItem(this.productdetaildataDt[f].productCategoryId));
									
									}else{
									window.localStorage.removeItem(this.productdetaildataDt[f].productCategoryId+"_"+a);
									//console.log("11222222222222222"+window.localStorage.getItem(this.productdetaildataDt[f].productCategoryId+"_"+a));
								}
							}
							/*	{
								if(window.localStorage.getItem(productAllData[f].productCategoryId+"_"+a)==null){
								window.localStorage.removeItem(productAllData[f].productCategoryId)+","+sendMultipledata;
								}else{
								window.localStorage.removeItem(productAllData[f].productCategoryId+"_"+a)+","+sendMultipledata;
								//console.log("11222222222222222"+window.localStorage.getItem(this.productdetaildataDt[f].productCategoryId+"_"+a));
								}
							}*/
						}}
				}
			}}
			window.localStorage.setItem('localid','2');
			//this.navCtrl.push(KiloPartyPage);
			this.navCtrl.setRoot(KiloPartyPage);
	}
	mycart()
	{
		this.navCtrl.setRoot(MycartPage)
	}
	//checkClick(cart.howManyItems,'',productdetaildataDt,pdd.productCategoryId,cart.howManyItems,pdd.prod//uctName,productdetaildataDt.indexOf(pdd),cart.productCategoryId)
	checkClick(howManyIte,checkClick,producrData, catID ,noOfItem,prodName,indexx,prodId,value){
		//console.log("aaaaaaaaaaaaaaaa"+howManyIte+"    prod data--->"+producrData+  "   categId--->"+catID+"   Choose Item--->"+noOfItem+"  Prod Name--->"+prodName+"  Index "+ indexx + "   prodId---->  "+prodId+" value=>"+value);
		if(howManyIte>1){
			var alreadyChecked = false;
			if(checkClick){
				for(var i=1; i<=howManyIte;i++){					
					if(window.localStorage.getItem(catID+"_"+i)==null){
						////console.log("CAT Id Set ==>"+catID+"_"+i+"               "+i);
						window.localStorage.setItem(catID+"_"+i,JSON.stringify(producrData[indexx]))
						//window.localStorage.setItem(prodName+"_"+i,prodName)
						//console.log("store Data1====>"+window.localStorage.getItem(prodName+"_"+i));
						alreadyChecked  = true;
						break;
						}	else{
						////console.log("in for else Loop "+i);
					}
				}
				}else{
				for(var i=1; i<=howManyIte;i++){
					
					if(window.localStorage.getItem(catID+"_"+i) != null){
						var prodValue =  window.localStorage.getItem(catID+"_"+i)
						//  //console.log("================>prodvAlue"+prodValue);
						// //console.log("====>json.string productdata ="+JSON.stringify(producrData[indexx]));
						if(prodValue == JSON.stringify(producrData[indexx]))
						{
							//console.log("Remove From Product List CAT ID -->"+catID+"_"+i);
							window.localStorage.removeItem(catID+"_"+i);
							//window.localStorage.removeItem(prodName+"_"+i);
							
							break;
						}
						
						alreadyChecked  = false;
						////console.log("Remove From Local-->"+window.localStorage.getItem(catID+"_"+i));
						
						}	else{
						////console.log("in for else Loop "+i);
					}
				}
				
			}
			}else{
			//console.log("Product Added in Category Id -->"+catID);
			window.localStorage.setItem(catID,JSON.stringify(producrData[indexx]));
			
			//console.log("store Data2====>"+window.localStorage.getItem(prodName));
		}
		this.refreshDataFold();
		return alreadyChecked;
		
	}
}



// WEBPACK FOOTER //
// ./src/pages/kilopartyproduct/kilopartyproduct.ts